export default {
  namespaced: true,
  state: {
    valid: false,
    foodSheet: "food",
    date: {
      date: new Date(new Date().setHours(12, 59, 0, 0))
        .toISOString()
        .substr(0, 10),
      menu: false,
    },
    time: {
      time: null,
      menu: false,
    },
    description: "",
    foodType: "",
    trip: "home",
    health: {
      list: ["Unhealthy", "", "Normal", "", "Healthy"],
      value: 2,
    },
    snackbar: {
      model: false,
      text: "Test",
      color: "secondary",
      timeout: 4000,
    },
  },
  getters: {},
  mutations: {
    UPDATE_FOOD_STATE: (state, payload) => {
      if (payload.field && payload.subfield) {
        state[payload.state][payload.field][payload.subfield] = payload.value;
      } else if (payload.field) {
        state[payload.state][payload.field] = payload.value;
      } else {
        state[payload.state] = payload.value;
      }
    },
  },
  actions: {
    updateFoodState: ({ commit }, payload) => {
      commit("UPDATE_FOOD_STATE", payload);
    },
  },
};
